<template>
  <div class="processed">
    <div class="content-top">
      <Select v-model="problemId" style="width:2rem" @on-change="changeList">
        <Option :value='0'>全部</Option>
        <Option v-for="item in problemList" :key="item.index" :value='item.type_id'>{{item.type_name}}</Option>
      </Select>
      <i-input search class="search" v-model.trim="content" @on-search="searchKeyword" placeholder="请输入问题描述关键词"> </i-input>
    </div>
    <div class="content">
      <Table border :columns="processedList" :data="dealProblemList.list"></Table>
      <Page :current="this.page" :total="dealProblemList.total" @on-change="changePage" style="margin-top: 0.1rem;float: right"/>
    </div>
  </div>
</template>

<script>
import {getProblemIndex, getProblemList} from '../../../api/api'
export default {
  name: 'processed',
  mounted () {
    this.init()
    // 获取实时总数
    let orignalSetItem = localStorage.setItem
    localStorage.setItem = function (key, newValue) {
      if (key === 'waitTotal') {
        let setItemEvent1 = new Event('setItemEvent1')
        setItemEvent1.newValue = newValue
        window.dispatchEvent(setItemEvent1)
        orignalSetItem.apply(this, arguments)
      } else if (key === 'processedTotal') {
        let setItemEvent2 = new Event('setItemEvent2')
        setItemEvent2.newValue = newValue
        window.dispatchEvent(setItemEvent2)
        orignalSetItem.apply(this, arguments)
      }
    }
  },
  data () {
    return {
      processedList: [
        {
          title: '问题类型',
          key: 'type_name',
          align: 'center'
        },
        {
          title: '问题描述',
          key: 'content',
          align: 'center',
          ellipsis: true
        },
        {
          title: '状态',
          key: 'status',
          align: 'center'
        },
        {
          title: '提交人',
          key: 'pname',
          align: 'center'
        },
        {
          title: '提交时间',
          key: 'pdate',
          align: 'center'
        },
        {
          title: '处理时间',
          key: 'hdate',
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'success'
                },
                style: {
                  marginRight: '5px',
                  backgroundColor: '#15bc41'
                },
                on: {
                  click: () => {
                    this.show2(params.row)
                  }
                }
              }, '查看详情')
            ])
          }
        }
      ],
      waitType: 0,
      problemList: [],
      content: null,
      page: 1,
      dealProblemList: [],
      problemId: 0,
      problemTheme: '全部',
      articleType: 1
    }
  },
  methods: {
    async init () {
      let index = parseInt(sessionStorage.getItem('selectId'))
      await this.getMatterType()
      await this.changeList(index)
    },
    async getMatterType () {
      const res = await getProblemList()
      if (res.code === 0) {
        if (res.data !== null) {
          this.problemList = res.data
        } else {
          this.problemList = []
        }
      }
    },
    async getDealProbelms () {
      let data = {
        tid: this.problemId,
        content: this.content,
        status: 1,
        page: this.page
      }
      const res = await getProblemIndex(data)
      if (res.code === 0) {
        if (res.data !== null) {
          this.dealProblemList = res.data
          this.dealProblemList.list.forEach((element, index) => {
            this.dealProblemList.list[index].status = '已处理'
          })
          localStorage.setItem('processedTotal', res.data.total)
          this.page = this.dealProblemList.page
        } else {
          this.dealProblemList.list = []
          this.page = 1
          localStorage.setItem('processedTotal', 0)
          this.dealProblemList.total = 0
          this.$Message.info('无相关数据')
        }
      }
    },
    async getDealProbelms2 () {
      let data = {
        tid: this.problemId,
        content: this.content,
        status: 0,
        page: this.page
      }
      const res = await getProblemIndex(data)
      if (res.code === 0) {
        if (res.data !== null) {
          localStorage.setItem('waitTotal', res.data.total)
        } else {
          localStorage.setItem('waitTotal', 0)
        }
      }
    },
    changeList (index) {
      // 下拉列表选择
      this.problemId = index
      sessionStorage.setItem('selectId', index)
      this.getDealProbelms()
      this.getDealProbelms2()
    },
    searchKeyword () {
      // 关键字搜索
      if (this.content === '') {
        this.content = null
        this.getDealProbelms()
      } else {
        this.getDealProbelms()
      }
    },
    changePage (index) {
      // 页码选择
      this.page = index
      this.getDealProbelms()
    },
    show2 (id) {
      sessionStorage.setItem('articleId', id.id)
      this.waitType = 2
      sessionStorage.setItem('waitType', this.waitType)
      sessionStorage.setItem('articleType', this.articleType)
      this.$router.push('proParticular')
    }
  }
}
</script>

<style scoped lang="stylus">
  .processed
    .content-top
      .ivu-input-wrapper .ivu-input-wrapper-default .ivu-input-type
        border-radius 0.1rem
      .search
        width:2.3rem
        margin-left: .2rem
  .content
    padding-top .2rem
</style>



// WEBPACK FOOTER //
// src/views/feedback/child/processed.vue